// utils
import { axiosInstance as axios } from '../../utils/axios';

// ----------------------------------------------------------------------

export function getSearch(text = '') {
  return async () => {
    try {
      const response = await axios.get('/search', {
        params: { search: text },
      });
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, data: error };
    }
  };
}

export function getModelSearch(link, text = '', size = 25) {
  return async () => {
    try {
      const response = await axios.get(link, {
        params: { search: text, page: 1, active: true, deleted: false, page_size: size },
      });
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, data: error };
    }
  };
}
